module.exports = __webpack_public_path__ + "static/media/icn_orchestra_60x60.eb334026.svg";